import types from './types';

export const invalidateCodeData = () => ({
  type: types.INVALIDATE_CODE_DATA,
});

export const useAvailableCreditRequest = () => ({
  type: types.USE_AVAILABLE_CREDIT_REQUEST,
});

export const verifyActivationCode = (code) => ({
  code,
  type: types.VERIFY_ACTIVATION_CODE_REQUEST,
});

export const activateActivationCode = () => ({
  type: types.ACTIVATE_ACTIVATION_CODE_REQUEST,
});

export const deactivateRecurringPayment = () => ({
  type: types.DEACTIVATE_RECURRING_PAYMENT_REQUEST,
});

export const activateMobileVideoLicence = () => ({
  type: types.ACTIVATE_MOBILE_VIDEO_LICENSE_REQUEST,
});

export const getVatVerification = () => ({
  type: types.GET_VAT_VERIFICATION_REQUEST,
});
